module.exports = __webpack_public_path__ + "img/about3.95d32524.jpg";